import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { connect } from "react-redux";
import Employee from "./employee";
import {
  onStickynoteDrop,
  onWorkplaceDrop,
  attemptAddWorkplaceToWeekday,
  cancelWorkplaceDrop,
  cancelStickynoteDrop,
  attemptGetEmployeeBookings,
  openEditBookingModal,
  openEditStickyNoteModal,
  attemptDeleteStickyNote,
  attemptDeleteBooking,
  toggleIsCompressed,
  setIsStartOfWeek,
  setEmployeeWeekoverviewDate,
  attemptAddStickyNoteToWeekday,
  attemptEditStickyNote,
} from "./actions";
import { setDate } from "../Workplace/DailyReport/actions";
import { Scrollbars } from "react-custom-scrollbars";
import WorkplaceDropModal from "./workplaceDropModal";
import StickyNoteDropModal from "./stickyNoteDropModal";
import { semanticColors } from "../../Globals/styles";
import PageSpinner from "../../Common/pageSpinner";
import WeekSwitch from "../../Common/weekSwitch";
import { getDates } from "../../Util/dateTime";
import { routeActions } from "redux-simple-router";
import Waves from "node-waves";

class EmployeeWeekOverview extends Component {
  componentWillMount = () => {
    this.props.dispatch(
      attemptGetEmployeeBookings(this.props.departmentId, this.props.date)
    );
  };
  componentDidMount = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  componentDidUpdate = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  toggleWeek = () => {
    this.props.dispatch(setIsStartOfWeek(!this.props.isStartOfWeek));
  };
  changeWeek = (date) => {
    this.props.dispatch(
      attemptGetEmployeeBookings(this.props.departmentId, date)
    );
    this.props.dispatch(setEmployeeWeekoverviewDate(date));
  };
  render() {
    const {
      employees,
      dispatch,
      droppedWorkplace,
      droppedStickynote,
      toggleSidebar,
      isLoading,
      workplaces,
      departmentId,
      workplacesFromOtherDepartments,
      isCompressed,
      date,
      isStartOfWeek,
    } = this.props;
    var weekDates = getDates(date);
    var allWorkplaces = Object.assign(
      {},
      workplaces,
      workplacesFromOtherDepartments
    );
    let employeeNodes = employees.map((employee, index) => {
      return (
        <div key={index} style={styles.weekdayContainer}>
          <Employee
            index={index}
            onWorkplaceDrop={(workplace, weekdayIndex) => {
              dispatch(onWorkplaceDrop(workplace, weekdayIndex, index));
            }}
            onStickynoteDrop={(weekdayIndex) => {
              dispatch(onStickynoteDrop(weekdayIndex, index));
            }}
            openEditBookingModal={(bookingIndex, weekdayIndex) =>
              dispatch(openEditBookingModal(bookingIndex, weekdayIndex, index))
            }
            openEditStickyNoteModal={(stickynoteIndex, weekdayIndex) =>
              dispatch(
                openEditStickyNoteModal(stickynoteIndex, weekdayIndex, index)
              )
            }
            employee={employee}
            workplaces={allWorkplaces}
            isStartOfWeek={isStartOfWeek}
            goToDagrapport={(workplaceId, weekDayIndex, hours) => {
              let monday = this.refs.weekSwitch.getMondayDate();
              var date = new Date(monday);
              date.setDate(date.getDate() + weekDayIndex);
              dispatch(setDate(date, null, hours ? employee.id : null));
              dispatch(
                routeActions.push(
                  "/afdeling/" +
                    departmentId +
                    "/arbejdssted/" +
                    workplaceId +
                    "/dagrapport"
                )
              );
            }}
            isCompressed={isCompressed}
          />
        </div>
      );
    });
    return (
      <div style={styles.outerContainer}>
        <div style={styles.container}>
          {isCompressed ? (
            <i
              className="fa fa-expand waves-icon"
              aria-hidden="true"
              style={styles.compressArrow}
              onClick={() => dispatch(toggleIsCompressed(!isCompressed))}
            ></i>
          ) : (
            <i
              className="fa fa-compress waves-icon"
              aria-hidden="true"
              style={styles.compressArrow}
              onClick={() => dispatch(toggleIsCompressed(!isCompressed))}
            ></i>
          )}

          <div style={styles.weekSwitchContainer}>
            <WeekSwitch
              ref="weekSwitch"
              initialDate={date}
              onChange={this.changeWeek}
              allowFuture={true}
              disableOnChangeOnMount={true}
            />
          </div>

          <i
            className="fa fa-times waves-icon"
            aria-hidden="true"
            style={styles.toggleSidebarCross}
            onClick={toggleSidebar}
          ></i>

          <div style={styles.weekdayHeadings}>
            <div style={styles.weekdayHeading} className="col-xs-3">
              {"man " + weekDates.mon.date.getDate()}
            </div>
            <div style={styles.weekdayHeading} className="col-xs-3">
              {"tir " + weekDates.tue.date.getDate()}
            </div>
            <div style={styles.weekdayHeading} className="col-xs-3">
              {"ons " + weekDates.wed.date.getDate()}
            </div>
            <div style={styles.weekdayHeading} className="col-xs-3">
              {"tor " + weekDates.thu.date.getDate()}
            </div>
            <div style={styles.weekdayHeading} className="col-xs-3">
              {"fre " + weekDates.fri.date.getDate()}
            </div>
            <div style={styles.weekdayHeading} className="col-xs-3">
              {"lør " + weekDates.sat.date.getDate()}
            </div>
            <div style={styles.weekdayHeading} className="col-xs-3">
              {"søn " + weekDates.sun.date.getDate()}
            </div>
          </div>

          {droppedWorkplace ? (
            <WorkplaceDropModal
              droppedWorkplace={droppedWorkplace}
              addWorkplaceToWeekday={(
                bookedWorkplace,
                weekdayIndex,
                employeeIndex,
                oldBookingIndex
              ) => {
                dispatch(
                  attemptAddWorkplaceToWeekday(
                    bookedWorkplace,
                    weekdayIndex,
                    employeeIndex,
                    date,
                    oldBookingIndex
                  )
                );
              }}
              attemptDeleteBooking={(
                bookedWorkplace,
                weekdayIndex,
                employeeIndex,
                oldBookingIndex
              ) => {
                dispatch(
                  attemptDeleteBooking(
                    bookedWorkplace,
                    weekdayIndex,
                    employeeIndex,
                    date,
                    oldBookingIndex
                  )
                );
              }}
              cancelWorkplaceDrop={() => {
                dispatch(cancelWorkplaceDrop());
              }}
            />
          ) : null}

          {droppedStickynote ? (
            <StickyNoteDropModal
              droppedStickynote={droppedStickynote}
              cancelStickynoteDrop={() => {
                dispatch(cancelStickynoteDrop());
              }}
              addStickyNoteToWeekday={(
                weekdayIndex,
                employeeIndex,
                stickynote
              ) => {
                dispatch(
                  attemptAddStickyNoteToWeekday(
                    weekdayIndex,
                    employeeIndex,
                    stickynote,
                    date
                  )
                );
              }}
              attemptEditStickyNote={(
                weekdayIndex,
                employeeIndex,
                stickynote,
                stickynoteIndex
              ) => {
                dispatch(
                  attemptEditStickyNote(
                    weekdayIndex,
                    employeeIndex,
                    stickynote,
                    stickynoteIndex,
                    date
                  )
                );
              }}
              attemptDeleteStickyNote={(
                weekdayIndex,
                employeeIndex,
                stickynoteIndex,
                stickynoteId
              ) =>
                dispatch(
                  attemptDeleteStickyNote(
                    weekdayIndex,
                    employeeIndex,
                    date,
                    stickynoteIndex,
                    stickynoteId
                  )
                )
              }
            />
          ) : null}

          <Scrollbars style={{ width: "100%", height: "100%" }}>
            {isLoading ? (
              <PageSpinner style={{ color: semanticColors.text }} />
            ) : (
              employeeNodes
            )}
          </Scrollbars>
        </div>
      </div>
    );
  }
}

var styles = {
  outerContainer: {
    height: "100%",
    width: "100%",
  },
  container: {
    paddingTop: "80px",
    height: "100%",
    position: "relative",
  },
  workplaces: {
    float: "left",
    width: "20%",
    height: "100%",
  },
  compressArrow: {
    position: "absolute",
    fontSize: "20px",
    right: "20px",
    top: "73px",
    height: "30px",
    width: "30px",
    textAlign: "center",
    lineHeight: "30px",
    zIndex: "10",
  },
  toggleArrow: {
    position: "absolute",
    fontSize: "20px",
    left: "14px",
    top: "40px",
    height: "30px",
    width: "30px",
    textAlign: "center",
    lineHeight: "30px",
    zIndex: "10",
  },
  toggleSidebarCross: {
    position: "absolute",
    fontSize: "20px",
    right: "5px",
    top: "5px",
    height: "40px",
    width: "40px",
    textAlign: "center",
    lineHeight: "40px",
    zIndex: "10",
  },
  weekdayHeadings: {
    position: "absolute",
    top: "50px",
    width: "100%",
    textAlign: "center",
    fontWeight: "600",
    borderBottom: "1px solid " + semanticColors.mainBackground,
    overflowX: "auto",
    whiteSpace: "nowrap",
  },
  weekdayContainer: {
    overflowX: "auto",
    whiteSpace: "nowrap",
  },
  weekdayHeading: {
    paddingLeft: "6px",
    paddingRight: "6px",
    display: "inline-block",
    float: "none",
    width: "14%",
  },
  weekSwitchContainer: {
    position: "absolute",
    top: "11px",
    left: "50%",
    marginLeft: "-125px",
  },
};

const selectProps = (state) => {
  return {
    ...state.bookEmployeeReducer,
    workplaces: state.kanbanReducer.workplaces,
  };
};

EmployeeWeekOverview.propTypes = {
  dispatch: PropTypes.func.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
  departmentId: PropTypes.string.isRequired,
  isCompressed: PropTypes.bool.isRequired,
  date: PropTypes.instanceOf(Date),
  isStartOfWeek: PropTypes.bool.isRequired,
};
export default connect(selectProps)(Radium(EmployeeWeekOverview));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/EmployeeWeekOverview/index.jsx